function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.wykonaj_test_st0{fill:none;stroke:#0052A5;stroke-width:1.68;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "wykonaj_test_st0",
  d: "M28.4,7.6c0-2.8-2.2-5-5.2-5S18,4.9,18,7.6h-6.2v8.7h23V7.6H28.4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "wykonaj_test_st0",
  d: "M34.8,12h3.1c2.9,0,5.2,2.2,5.2,5.4V54c0,2.9-2.2,5.4-5.2,5.4H8.6c-2.9,0-5.2-2.2-5.2-5.4V17.1 c0-2.9,2.2-5.4,5.2-5.4h3.1"
});

var _ref5 = /*#__PURE__*/React.createElement("polyline", {
  className: "wykonaj_test_st0",
  points: "8.3,26.1 10.9,28.6 17.5,22.5 "
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "wykonaj_test_st0",
  x1: 22,
  y1: 25.6,
  x2: 35.8,
  y2: 25.6
});

var _ref7 = /*#__PURE__*/React.createElement("polyline", {
  className: "wykonaj_test_st0",
  points: "8.3,38.4 10.9,40.9 17.5,34.8 "
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  className: "wykonaj_test_st0",
  x1: 22,
  y1: 37.7,
  x2: 35.8,
  y2: 37.7
});

var _ref9 = /*#__PURE__*/React.createElement("polyline", {
  className: "wykonaj_test_st0",
  points: "8.3,49.2 10.9,51.6 17.5,45.5 "
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  className: "wykonaj_test_st0",
  x1: 22,
  y1: 48.5,
  x2: 35.8,
  y2: 48.5
});

var SvgWykonajTest = function SvgWykonajTest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 64",
    style: {
      enableBackground: "new 0 0 48 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWykonajTest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wykonaj-test.6e17f48b.svg";
export { ForwardRef as ReactComponent };